export class Permission {
  id: string;
  name: string;
  collectionName: string;
  access: string;
  extensions: string[];
}

/**
 * Permission name marking a user as the agency's admin account (business rule, PUL-3023).
 *
 * Shared by both apps: the cs agency screens and the admin impersonation entry point both
 * need to single out that account.
 */
export const AGENCY_ADMIN_PERMISSION = 'agency_admin';
